// src/StackOverflowIcon.tsx
import { jsx } from "react/jsx-runtime";
var StackOverflowIcon = ({ ...props }) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "25",
    viewBox: "0 0 16 25",
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M14.6079 24.2495H0.148926V15.7162H1.74893V22.1162H13.0079V15.7162H14.6079V24.2495ZM11.4079 19.9828H3.34893V17.8495H11.4039V19.9828H11.4079ZM11.4079 17.3162L3.54893 15.1308L3.88693 13.0615L11.7479 15.2508L11.4049 17.3162H11.4079ZM11.8469 14.6002L4.56693 10.0668V10.0588L5.24093 8.11618L12.5219 12.6495L11.8489 14.6015L11.8469 14.6002ZM12.7699 12.1402L6.59993 5.28685H6.60893L7.62193 3.66818L13.7839 10.5162L12.7669 12.1415L12.7699 12.1402ZM14.0779 10.1402L9.27093 1.54151L10.5809 0.249512L15.3869 8.85085L14.0749 10.1455L14.0779 10.1402Z",
        fill: "#0095E4"
      }
    )
  }
);
var StackOverflowIcon_default = StackOverflowIcon;

export {
  StackOverflowIcon_default
};
